var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "choice",
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.289,
    height: 180.714,
    viewBox: "0 0 223.289 180.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1147",
    "data-name": "Grupo 1147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1032",
    "data-name": "Rect\\xE1ngulo 1032",
    width: 223.289,
    height: 180.714,
    rx: 10.909,
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1142",
    "data-name": "Grupo 1142",
    transform: "translate(22.917 16.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1033",
    "data-name": "Rect\\xE1ngulo 1033",
    width: 178.179,
    height: 41.033,
    rx: 7.115,
    fill: "#005cba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1141",
    "data-name": "Grupo 1141",
    transform: "translate(139.684 10.177)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_135",
    "data-name": "Elipse 135",
    cx: 10.34,
    cy: 10.34,
    r: 10.34,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2919",
    "data-name": "Trazado 2919",
    d: "M232.818,1896.615l3.494,3.161,7.55-9.322",
    transform: "translate(-227.86 -1884.639)",
    fill: "none",
    stroke: "#007eff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1034",
    "data-name": "Rect\\xE1ngulo 1034",
    width: 55.97,
    height: 13.765,
    transform: "translate(12.184 14.687)",
    fill: "#fff",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1144",
    "data-name": "Grupo 1144",
    transform: "translate(22.917 72.412)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1035",
    "data-name": "Rect\\xE1ngulo 1035",
    width: 178.179,
    height: 41.033,
    rx: 7.115,
    fill: "#005cba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1143",
    "data-name": "Grupo 1143",
    transform: "translate(139.684 10.176)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_136",
    "data-name": "Elipse 136",
    cx: 10.34,
    cy: 10.34,
    r: 10.34,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2920",
    "data-name": "Trazado 2920",
    d: "M232.818,1916.134l3.494,3.161,7.55-9.323",
    transform: "translate(-227.86 -1904.158)",
    fill: "none",
    stroke: "#007eff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1036",
    "data-name": "Rect\\xE1ngulo 1036",
    width: 120.028,
    height: 13.765,
    transform: "translate(12.184 14.687)",
    fill: "#fff",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1146",
    "data-name": "Grupo 1146",
    transform: "translate(22.917 128.437)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1037",
    "data-name": "Rect\\xE1ngulo 1037",
    width: 178.179,
    height: 41.033,
    rx: 7.115,
    fill: "#005cba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1145",
    "data-name": "Grupo 1145",
    transform: "translate(139.684 10.177)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_137",
    "data-name": "Elipse 137",
    cx: 10.34,
    cy: 10.34,
    r: 10.34,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2921",
    "data-name": "Trazado 2921",
    d: "M232.818,1935.652l3.494,3.161,7.55-9.322",
    transform: "translate(-227.86 -1923.677)",
    fill: "none",
    stroke: "#007eff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1038",
    "data-name": "Rect\\xE1ngulo 1038",
    width: 59.205,
    height: 13.765,
    transform: "translate(12.184 14.687)",
    fill: "#fff",
    opacity: 0.15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoice);
export default __webpack_public_path__ + "static/media/choice.70ac820d.svg";
export { ForwardRef as ReactComponent };